import { render } from "./QuestionArchive.vue?vue&type=template&id=91755cee&scoped=true"
import script from "./QuestionArchive.vue?vue&type=script&lang=js"
export * from "./QuestionArchive.vue?vue&type=script&lang=js"

import "./QuestionArchive.vue?vue&type=style&index=0&id=91755cee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91755cee"]])

export default __exports__